import { defineComponent as _defineComponent } from 'vue';
import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../assets/image/logo.png';
const _hoisted_1 = { class: "header-placeholder" };
const _hoisted_2 = { class: "header-container" };
const _hoisted_3 = { class: "nav-container" };
const _hoisted_4 = { class: "nav" };
import { ref, onMounted, onUnmounted } from "vue";
import { useRouter } from "vue-router";
import Login from "./Login.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Header',
    setup(__props) {
        const isFixed = ref(false);
        const router = useRouter();
        const showLogin = ref(false);
        const clickCount = ref(0);
        const handleScroll = () => {
            isFixed.value = window.scrollY > 50;
        };
        onMounted(() => {
            window.addEventListener("scroll", handleScroll);
        });
        onUnmounted(() => {
            window.removeEventListener("scroll", handleScroll);
        });
        const handleLogoClick = () => {
            clickCount.value++;
            if (clickCount.value >= 8) {
                showLogin.value = true;
                clickCount.value = 0;
            }
            else {
                router.push("/");
            }
        };
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _withDirectives(_createElementVNode("div", _hoisted_1, null, 512), [
                    [_vShow, isFixed.value]
                ]),
                _createElementVNode("header", {
                    class: _normalizeClass(["header", { fixed: isFixed.value }])
                }, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", {
                                class: "logo",
                                onClick: handleLogoClick
                            }, [...(_cache[1] || (_cache[1] = [
                                    _createElementVNode("img", {
                                        src: _imports_0,
                                        alt: "爱布软件"
                                    }, null, -1)
                                ]))]),
                            _createElementVNode("nav", _hoisted_4, [
                                _createVNode(_component_router_link, {
                                    to: "/",
                                    class: _normalizeClass(["nav-item", { active: _ctx.$route.path === '/' }])
                                }, {
                                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                            _createTextVNode("首页", -1)
                                        ]))]),
                                    _: 1
                                }, 8, ["class"]),
                                _createVNode(_component_router_link, {
                                    to: "/about",
                                    class: _normalizeClass(["nav-item", { active: _ctx.$route.path === '/about' }])
                                }, {
                                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                            _createTextVNode("关于我们", -1)
                                        ]))]),
                                    _: 1
                                }, 8, ["class"]),
                                _createVNode(_component_router_link, {
                                    to: "/cases",
                                    class: _normalizeClass(["nav-item", { active: _ctx.$route.path === '/cases' }])
                                }, {
                                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                            _createTextVNode("典型案例", -1)
                                        ]))]),
                                    _: 1
                                }, 8, ["class"]),
                                _createVNode(_component_router_link, {
                                    to: "/products",
                                    class: _normalizeClass(["nav-item", { active: _ctx.$route.path === '/products' }])
                                }, {
                                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                            _createTextVNode("产品分类", -1)
                                        ]))]),
                                    _: 1
                                }, 8, ["class"]),
                                _createVNode(_component_router_link, {
                                    to: "/contact",
                                    class: _normalizeClass(["nav-item", { active: _ctx.$route.path === '/contact' }])
                                }, {
                                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                            _createTextVNode("联系我们", -1)
                                        ]))]),
                                    _: 1
                                }, 8, ["class"]),
                                _createVNode(_component_router_link, {
                                    to: "/cooperation",
                                    class: _normalizeClass(["nav-item", { active: _ctx.$route.path === '/cooperation' }])
                                }, {
                                    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                            _createTextVNode("商务合作", -1)
                                        ]))]),
                                    _: 1
                                }, 8, ["class"])
                            ])
                        ]),
                        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "download-btn" }, "立即下载", -1))
                    ])
                ], 2),
                _createVNode(Login, {
                    visible: showLogin.value,
                    "onUpdate:visible": _cache[0] || (_cache[0] = ($event) => ((showLogin).value = $event))
                }, null, 8, ["visible"])
            ], 64));
        };
    }
});
